module.exports = __webpack_public_path__ + "img/bluecircle.4c890fa4.svg";